<template>
  <div id="app">

    <navbar
      v-bind:currentUser="currentUser"
      v-bind:isLogin="isLogin"
    ></navbar>

    <div class="contents">
      <router-view
        v-bind:currentUser="currentUser"
        v-bind:isLogin="isLogin"
      ></router-view>
    </div>

    <footer class="footer">
      <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="has-text-left">
              <a href="/events/create" title="イベント作成">
                <b-icon icon="plus-circle" pack="fas" type="is-primary"></b-icon>
                イベント作成
              </a>
            </p>
            <p class="has-text-left">
              <a href="http://futsal.mystrikingly.com/" target="_blank">フットサルメットについて</a>
            </p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div class="has-text-centered">
            <a href="https://twitter.com/futsalmet" title="FutsalMet Twitter Account" target="_blank">
              <b-icon icon="twitter" pack="fab" size="is-medium" type="is-primary"></b-icon>
            </a>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="has-text-left">
              <a href="https://players1.st/terms" target="_blank">利用規約</a>
            </p>
            <p class="has-text-left">
              <a href="https://players1.st/privacy" target="_blank">個人情報保護方針</a>
            </p>
          </div>
        </div>
      </nav>

      <div class="content has-text-centered">
        <p>
          &copy; {{ new Date().getFullYear() }} <a href="https://company.players1.st" target="_blank">Players1st inc.</a>
        </p>
      </div>
    </footer>

  </div>
</template>

<script>
import firebase from '@/firebase/firebase'
import navbar from "@/components/Navbar"

export default {
  components: {
    navbar
  },
  data() {
    return {
      isLogin: false,
      currentUser: null
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.currentUser = user
        this.isLogin = true
        console.log('Status: Login');
      } else {
        this.currentUser = null
        this.isLogin = false
        console.log('Status: NOT Login');
      }
    }, function(error) {
      console.log(error);
    })
  },
  metaInfo: {
    title: 'フットサルメンバー募集',
    titleTemplate: '%s | FutsalMet'
  }
}
</script>

<style>
.contents {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
